function getProductByOffset(allProducts, currentProduct, offset) {
  if (allProducts && currentProduct) {
    const index = allProducts.findIndex(
      product => product.uuid === currentProduct.uuid
    )
    if (index !== null) {
      if (index + offset < allProducts.length) {
        return allProducts[index + offset]
      }
    }
  }

  return null
}

function getTagProducts(state, tag) {
  if (tag && state.loadMenuDataReducers.data?.products) {
    return state.loadMenuDataReducers.data.products.filter(
      product => product.tags && product.tags.includes(tag)
    )
  }
}

const selectors = {
  isLoading: state => state.loadMenuDataReducers.loading,
  getError: state => state.loadMenuDataReducers.error,
  getData: state => state.loadMenuDataReducers.data,
  getColors: state => state.loadMenuDataReducers?.data?.colors || {},
  getStoreCode: state => state.loadMenuDataReducers?.storeCode,

  getNavigations: state => state.loadMenuDataReducers.data?.navigations || [],
  getNavigation: (navigationId) => state => state.loadMenuDataReducers.data?.navigations.find(nav => `${nav.id}` === `${navigationId}`),
  getNavigationProduct: (navigationId, productCode) => state => {
    const navigation = state.loadMenuDataReducers.data?.navigations.find(nav => `${nav.id}` === `${navigationId}`)
    return navigation?.allProducts.find(product => `${product.productCode}` === `${productCode}`)
  },
  getNavigationNextProduct: (navigationId, productCode) => state => {
    const navigation = state.loadMenuDataReducers.data?.navigations.find(nav => `${nav.id}` === `${navigationId}`)
    const currentProduct = navigation?.allProducts.find(product => `${product.productCode}` === `${productCode}`)
    return getProductByOffset(navigation?.allProducts, currentProduct, +1)
  },
  getNavigationPreviousProduct: (navigationId, productCode) => state => {
    const navigation = state.loadMenuDataReducers.data?.navigations.find(nav => `${nav.id}` === `${navigationId}`)
    const currentProduct = navigation?.allProducts.find(product => `${product.productCode}` === `${productCode}`)
    return getProductByOffset(navigation?.allProducts, currentProduct, -1)
  },


  getTags: state => state.loadMenuDataReducers.data?.tags || [],
  getTagProducts: tag => state => {
    return getTagProducts(state, tag)
  },
  getTagProduct: (tag, productCode) => state => {
    const tagProducts = getTagProducts(state, tag)
    return tagProducts?.find(product => `${product.productCode}` === `${productCode}`)
  },
  getTagNextProduct: (tag, productCode) => state => {
    const tagProducts = getTagProducts(state, tag)
    const currentProduct = tagProducts?.find(product => `${product.productCode}` === `${productCode}`)
    return getProductByOffset(tagProducts, currentProduct, +1)
  },
  getTagPreviousProduct: (tag, productCode) => state => {
    const tagProducts = getTagProducts(state, tag)
    const currentProduct = tagProducts?.find(product => `${product.productCode}` === `${productCode}`)
    return getProductByOffset(tagProducts, currentProduct, -1)
  },
}

export { selectors }
